export const questionnaire = [
  {
    id: 1,
    text: "When did you first have your blood glucose level checked?*",
    name: "answer_1",
    options: [
      { label: "This is my first time", value: 0 },
      { label: "Before age 30", value: 1 },
      { label: "Between 30–39", value: 2 },
      { label: "Between 40–49 ", value: 3 },
      { label: "50 or older", value: 4 },
    ],
  },
  {
    id: 2,
    text: "How old were you when you were first told you had high blood glucose or prediabetes?*",
    name: "answer_2",
    options: [
      { label: "I’ve never been told", value: 0 },
      { label: "Below 30", value: 1 },
      { label: "30–39", value: 2 },
      { label: "40–49", value: 3 },
      { label: "50 or older", value: 4 },
      { label: "Not sure", value: 4 },
    ],
  },
  {
    id: 3,
    text: "Which of the following have you had to cut back on or delay due to diabetes-related costs? (Select all that apply)",
    name: "answer_3",
    isCheckbox: true,
    options: [
      {
        label: "Regular medical check-ups",
        value: 0,
      },
      { label: "Blood glucose testing supplies", value: 1 },
      { label: "Healthier food choices", value: 2 },
      { label: "Leisure or family spending", value: 3 },
      { label: "Other household expenses", value: 4 },
      { label: "There is no need to cut back", value: 4 },
    ],
  },
];
